import VueRecaptcha from 'vue-recaptcha';

const ENABLE_RECAPTCHA = true;

export default {
	components: {
		VueRecaptcha
	},
	data() {
		return {
			googleRecaptchaSiteKey: ENABLE_RECAPTCHA && window.context.googleRecaptcha
		};
	},
	methods: {
		onRecaptchaVerify(token) {
			token && this.sendForm(token);
		},
		resetRecaptcha() {
			this.$refs.vueReCaptcha.reset();
		},
		submitForm() {
			this.googleRecaptchaSiteKey && this.$refs.vueReCaptcha ? this.$refs.vueReCaptcha.execute() : this.sendForm();
		}
	}
};



// WEBPACK FOOTER //
// ../source/common/recaptcha/recaptcha-mixin.js